import { getMaxAclDuration } from './PermissionHandler';
import moment from 'moment';

export const DATE_FORMAT_DISPLAY = 'DD-MM-YYYY HH:mm:ss';
export const SHORT_DATE_FORMAT_DISPLAY = 'DD-MM-YYYY';
export const DATE_FORMAT_FILE_NAME = 'DD-MM-YYYY-HH-mm-ss';
export const DATE_FORMAT_UTC = 'YYYY-MM-DD HH:mm:ss';
export const TIME_FORMAT_DURATION = 'HH:mm:ss';
export const DATE_TIME_PICKER_FORMAT = 'dd-MM-yyyy HH:mm:ss';
export const EXPIRED_DATE_FORMAT = 'dd-MM-yyyy';
export const EXPIRED_DATE_FORMAT_UTC = 'YYYY-MM-DD';

export const formatLocalDateForDispaly = (date) => {
  return moment.utc(date).local().format(DATE_FORMAT_DISPLAY);
};
export const formatLocalDateForAcl = (date) => {
  return moment.utc(date).local().format(SHORT_DATE_FORMAT_DISPLAY);
};

export const getMaxDateForAccessExpiry = (date) => {
  const maxAclDuration = getMaxAclDuration();
  return moment(date).add(maxAclDuration, 'days');
};
export const formatLocalDateForFileDownload = (date) => {
  return moment.utc(date).local().format(DATE_FORMAT_FILE_NAME);
};
export const formatLocalDateForLastSuccessfulLogin = (date) => {
  return moment.utc(date).local().format(DATE_FORMAT_DISPLAY);
};

export const formatUTCDate = (date) => {
  return moment(date).utc().format(DATE_FORMAT_UTC);
};

export const formatUTCDateForExpired = (date) => {
  return moment(date).utc().format(EXPIRED_DATE_FORMAT_UTC);
};

export const addDurationForEndTime = (startTime, duration) => {
  return moment
    .utc(startTime)
    .add(duration, 'seconds')
    .local()
    .format(DATE_FORMAT_DISPLAY);
};
export const addDurationMinutes = (startTime, duration) => {
  return moment
    .utc(startTime)
    .add(duration, 'minutes')
    .local()
    .format(DATE_FORMAT_DISPLAY);
};
export const addDurationHour = (startTime, duration) => {
  return moment
    .utc(startTime)
    .add(duration, 'hours')
    .local()
    .format(DATE_FORMAT_DISPLAY);
};
export const formatDuration = (date) => {
  return moment.utc(date * 1000).format(TIME_FORMAT_DURATION);
};

export const getLastUpdate = (date) => {
  return moment.utc(date).local().fromNow();
};

export const diffTime = (startDate, endDate) => {
  let d1 = moment(startDate);
  let d2 = moment(endDate);
  let totalSeconds = d2.diff(d1, 'seconds');
  return totalSeconds;
};

export const currentUTCTime = formatUTCDate(moment());

export const formatDateToString = (datetime) => {
  const date = new Date(datetime);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return [year, month, day].join('-');
};

export const addOneDayForACLCheck = (date) => {
  return moment.utc(date).add(1, 'days');
};

export const getCurrentUTCDate = () => {
  let currentDate = new Date();
  currentDate.setHours(0);
  currentDate.setMinutes(0);
  currentDate.setSeconds(0);
  return currentDate;
};

export const checkAclExpiredDate = (accessExpiry) => {
  if (accessExpiry) {
    const expiredDate = moment(new Date(accessExpiry)).format('YYYY/MM/DD');
    const currentDate = moment(new Date(getCurrentUTCDate())).format('YYYY/MM/DD');
    if (currentDate < expiredDate) {
      return true;
    } else if (currentDate > expiredDate) {
      return false;
    } else {
      return true;
    }
  }
  return true;
};
